import script from "./PlayerInfoTile.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlayerInfoTile.vue?vue&type=script&setup=true&lang=ts"

import "./PlayerInfoTile.vue?vue&type=style&index=0&id=29c9165d&scoped=true&lang=css"

import exportComponent from "/Users/samuel/KTH/DynWeb/ssoderbe-wrmvd-ht22-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29c9165d"]])

export default __exports__